import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "about" }
const _hoisted_2 = { class: "container pt-5 my-3 vh-75" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-1 col-md-2" }, null, -1)
const _hoisted_5 = { class: "col-10 col-md-8 text-box" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-1 col-md-2" }, null, -1)
const _hoisted_7 = { class: "container vh-75 my-3 px-5" }
const _hoisted_8 = { class: "card-deck row row-cols-1 p-5" }
const _hoisted_9 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MemberCard = _resolveComponent("MemberCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('ABOUT.COMPANY_INTRO')), 1),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.companyIntro[0]), 1),
        _hoisted_6
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('ABOUT.MEMBER')), 1),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.membersIntro, (member) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_MemberCard, {
              name: member.name,
              "img-url": member.image,
              position: member.position,
              content: member.description
            }, null, 8, ["name", "img-url", "position", "content"])
          ]))
        }), 256))
      ])
    ])
  ]))
}